import type { PreviewTarget } from '../types/PreviewTarget'

/** @internal storage key; do not import from callers outside this folder + tests */
export const PREVIEW_TARGET_STORAGE_KEY = 'fuellox.previewTarget'

function storageGet (key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null
  } catch {
    return null
  }
}

function storageSet (key: string, value: string): void {
  try {
    globalThis.localStorage.setItem(key, value)
  } catch {
    return
  }
}

function storageRemove (key: string): void {
  try {
    globalThis.localStorage.removeItem(key)
  } catch {
    return
  }
}

function parsePreviewTarget (raw: string): PreviewTarget | undefined {
  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    return undefined
  }
  if (parsed === null || typeof parsed !== 'object') {
    return undefined
  }
  const record = parsed as Record<string, unknown>
  if (typeof record.apiUrl !== 'string' || record.apiUrl.length === 0) {
    return undefined
  }
  if (typeof record.capgoChannel !== 'string' || record.capgoChannel.length === 0) {
    return undefined
  }
  return {
    apiUrl: record.apiUrl,
    capgoChannel: record.capgoChannel,
  }
}

export function readPreviewTarget (): PreviewTarget | undefined {
  const raw = storageGet(PREVIEW_TARGET_STORAGE_KEY)
  if (raw === null || raw === '') {
    return undefined
  }
  return parsePreviewTarget(raw)
}

export function writePreviewTarget (target: PreviewTarget): void {
  if (typeof target.apiUrl !== 'string' || target.apiUrl.length === 0) {
    throw new Error('PreviewTarget.apiUrl must be a non-empty string')
  }
  if (typeof target.capgoChannel !== 'string' || target.capgoChannel.length === 0) {
    throw new Error('PreviewTarget.capgoChannel must be a non-empty string')
  }
  storageSet(PREVIEW_TARGET_STORAGE_KEY, JSON.stringify({
    apiUrl: target.apiUrl,
    capgoChannel: target.capgoChannel,
  }))
}

export function clearPreviewTarget (): void {
  storageRemove(PREVIEW_TARGET_STORAGE_KEY)
}
